import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const PinterestSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="1.5 -6.5 12 28"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        d="m8 0c-4.4 0-8 3.6-8 8 0 3.3 2 6.1 4.8 7.3 0-.6-.00001-1.2.09999-1.8.2-.7 1-4.4 1-4.4s-.29998-.5-.29998-1.3c0-1.2.7-2.1 1.5-2.1.7 0 1.09999.5 1.09999 1.2s-.5 1.8-.7 2.8c-.2.8.4 1.5 1.3 1.5 1.5 0 2.5-1.9 2.5-4.3 0-1.8-1.2-3.1-3.3-3.1-2.4 0-3.89999 1.8-3.89999 3.8 0 .7.2 1.2.5 1.6.1.2.19999.2.09999.4 0 .1-.1.5-.2.6-.1.2-.19999.3-.39999.2-1.1-.5-1.60001-1.7-1.60001-3.1 0-2.3 1.9-5 5.7-5 3.1 0 5.1 2.2 5.1 4.6 0 3.1-1.7 5.5-4.3 5.5-.9 0-1.7-.5-2-1 0 0-.50001 1.8-.60001 2.2-.2.6-.49998 1.2-.79998 1.7.7.2 1.49998.3 2.29998.3 4.40001 0 8.00001-3.6 8.00001-8 .1-4-3.5-7.6-7.9-7.6z"
      />
    </Svg>
  )
}

export default PinterestSvg
